import { PropTypes } from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getPid, getProject } from '../../utils/utils';
import { useSelector } from 'react-redux';

export const MainContext = React.createContext({});

export default function MainContextProvider({ children }) {
  const { list } = useSelector(({ projects }) => projects);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState(undefined);
  const [project, setProject] = useState(undefined);
  const [showUploadDelayInfo, setShowUploadDelayInfo] = useState(false);
  const { id } = useParams();
  const { search } = useLocation();

  useEffect(() => {
    if ((id || search) && list.length) {
      const project = getProject(id || getPid(search));
      if (project) {
        setProject(project);
      } else {
        navigate('/projects');
      }
    }
  }, [id, list.length, navigate, search]);

  const value = useMemo(
    () => ({
      loading,
      setLoading,
      error,
      project,
      setError,
      showUploadDelayInfo,
      setShowUploadDelayInfo,
    }),
    [error, loading, project, showUploadDelayInfo],
  );

  return <MainContext.Provider value={value}>{children}</MainContext.Provider>;
}

MainContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
};
